import React, { useEffect, useState, useRef } from 'react';
import { dashAPI, productAPI, orderAPI, returnAPI, walletAPI, dealAPI, profileAPI, notifAPI } from './SellerApi';

export const SellerDeals = () => {
  const [deals,    setDeals]    = useState([]);
  const [products, setProducts] = useState([]);
  const [form,     setForm]     = useState({ product_id:'', discount_pct:'', label:'', starts_at:'', ends_at:'' });
  const [loading,  setLoading]  = useState(true);
  const [success,  setSuccess]  = useState('');

  useEffect(() => {
    // Call both APIs simultaneously
    Promise.all([dealAPI.list(), productAPI.list()])
      .then(([d, p]) => {
        // Ensure data exists before setting
        setDeals(Array.isArray(d.data) ? d.data : []);
        setProducts(Array.isArray(p.data) ? p.data : []);
      })
      .catch((err) => {
        console.error("Failed to fetch data:", err);
        // REMOVE the mock data here so you don't see wrong products
        setDeals([]);
        setProducts([]);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      const res = await dealAPI.create(form);
      setDeals(d => [res.data, ...d]);
      setSuccess('Deal created!'); setForm({product_id:'',discount_pct:'',label:'',starts_at:'',ends_at:''});
    } catch (err) { alert(err.message); }
  };

  return (
    <div style={{display:'grid',gridTemplateColumns:'1fr 1.5fr',gap:'1.5rem'}}>
      <div className="sp-card">
        <div className="sp-card-title">Create New Deal</div>
        {success && <div className="sp-success">{success}</div>}
        <form onSubmit={handleCreate}>
          <div className="sp-input-group">
            <label className="sp-label">SELECT PRODUCT</label>
            <select className="sp-select" value={form.product_id} onChange={e => setForm(f=>({...f,product_id:e.target.value}))} required>
              <option value="">Choose product…</option>
              {products.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </div>
          <div className="sp-input-row">
            <div className="sp-input-group">
              <label className="sp-label">DISCOUNT %</label>
              <input className="sp-input" type="number" min={1} max={90} placeholder="e.g. 20" value={form.discount_pct} onChange={e => setForm(f=>({...f,discount_pct:e.target.value}))} required />
            </div>
            <div className="sp-input-group">
              <label className="sp-label">DEAL LABEL</label>
              <input className="sp-input" type="text" placeholder="e.g. Weekend Sale" value={form.label} onChange={e => setForm(f=>({...f,label:e.target.value}))} />
            </div>
          </div>
          <div className="sp-input-row">
            <div className="sp-input-group">
              <label className="sp-label">START DATE</label>
              <input className="sp-input" type="date" value={form.starts_at} onChange={e => setForm(f=>({...f,starts_at:e.target.value}))} />
            </div>
            <div className="sp-input-group">
              <label className="sp-label">END DATE</label>
              <input className="sp-input" type="date" value={form.ends_at} onChange={e => setForm(f=>({...f,ends_at:e.target.value}))} required />
            </div>
          </div>
          <button type="submit" className="sp-btn-primary" style={{width:'100%'}}>🏷️ Create Deal</button>
        </form>
      </div>

      <div>
        <div className="sp-card-title" style={{marginBottom:'1rem'}}>Active Deals</div>
        {loading ? <div className="sp-skeleton" style={{height:200,borderRadius:'var(--r-lg)'}} /> : (
          <div className="sp-deals-grid">
            {deals.map(d => (
              <div key={d.id} className="sp-deal-card">
                <div className="sp-deal-top">
                  <div>
                    <div className="sp-deal-name">{d.product_name}</div>
                    {d.label && <div className="sp-deal-meta">{d.label}</div>}
                  </div>
                  <span className="sp-deal-disc">{d.discount_pct}% OFF</span>
                </div>
                <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginTop:8}}>
                  <span className={`sp-badge ${d.status}`}>{d.status}</span>
                  <span style={{fontSize:11,color:'var(--t3)'}}>Ends {d.ends_at ? new Date(d.ends_at).toLocaleDateString('en-IN') : '—'}</span>
                </div>
                <button className="sp-btn-danger" style={{width:'100%',marginTop:'0.75rem',fontSize:12}} onClick={() => dealAPI.delete(d.id).then(() => setDeals(ds => ds.filter(x=>x.id!==d.id))).catch(console.error)}>
                  Remove Deal
                </button>
              </div>
            ))}
            {deals.length===0 && <p style={{color:'var(--t3)',fontSize:13,gridColumn:'1/-1'}}>No active deals. Create your first deal!</p>}
          </div>
        )}
      </div>
    </div>
  );
};

export default SellerDeals;